import { render } from "./choosePlan.vue?vue&type=template&id=7bb76b8e&scoped=true"
import script from "./choosePlan.vue?vue&type=script&lang=js"
export * from "./choosePlan.vue?vue&type=script&lang=js"

import "./choosePlan.vue?vue&type=style&index=0&id=7bb76b8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb76b8e"]])

export default __exports__